export default __webpack_public_path__ + "static/media/chat-icon.582a9a9a.svg";